import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Account,  AccountListFilter } from '../account.model';

export enum AccountActionTypes {
  GetAccounts = '[Account] Get Accounts',
  GetAllAccounts = '[Account] Get All Accounts',
  // GetAccountList = '[Account] Get AccountList',
  LoadAccounts = '[Account] Load Accounts',
  AddAccount = '[Account] Add Account',
  UpsertAccount = '[Account] Upsert Account',
  AddAccounts = '[Account] Add Accounts',
  UpsertAccounts = '[Account] Upsert Accounts',
  UpdateAccount = '[Account] Update Account',
  UpdateAccounts = '[Account] Update Accounts',
  DeleteAccount = '[Account] Delete Account',
  DeleteAccounts = '[Account] Delete Accounts',
  ClearAccounts = '[Account] Clear Accounts',
  GetAccountsFail = '[Account] Get Accounts Fail',
  NoAccountsChanged = '[Account] No Accounts Changed',
  GetClientAccount = '[Account] Get Client Account'
}

export class GetAccounts {
  readonly type = AccountActionTypes.GetAccounts;

  constructor(public payload: any = null) {}
}

export class GetAllAccounts {
  readonly type = AccountActionTypes.GetAllAccounts;
}

// export class GetAccountList implements Action {
//   readonly type = AccountActionTypes.GetAccountList;
//   constructor(public payload: number[]) {}
// }

export class LoadAccounts implements Action {
  readonly type = AccountActionTypes.LoadAccounts;

  constructor(public payload: { accounts: Account[] }) {}
}

export class GetAccountsFail implements Action {
  readonly type = AccountActionTypes.GetAccountsFail;
}

export class AddAccount implements Action {
  readonly type = AccountActionTypes.AddAccount;

  constructor(public payload: { account: Account }) {}
}

export class UpsertAccount implements Action {
  readonly type = AccountActionTypes.UpsertAccount;

  constructor(public payload: { account: Account }) {}
}

export class AddAccounts implements Action {
  readonly type = AccountActionTypes.AddAccounts;

  constructor(public payload: { accounts: Account[] }) {}
}

export class UpsertAccounts implements Action {
  readonly type = AccountActionTypes.UpsertAccounts;

  constructor(public payload: { accounts: Account[] }) {}
}

export class UpdateAccount implements Action {
  readonly type = AccountActionTypes.UpdateAccount;

  constructor(public payload: { account: Update<Account> }) {}
}

export class UpdateAccounts implements Action {
  readonly type = AccountActionTypes.UpdateAccounts;

  constructor(public payload: { accounts: Update<Account>[] }) {}
}

export class DeleteAccount implements Action {
  readonly type = AccountActionTypes.DeleteAccount;

  constructor(public payload: { id: string }) {}
}

export class DeleteAccounts implements Action {
  readonly type = AccountActionTypes.DeleteAccounts;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearAccounts implements Action {
  readonly type = AccountActionTypes.ClearAccounts;
}

export class NoAccountsChanged  implements Action {
  readonly type = AccountActionTypes.NoAccountsChanged;
}

export class GetClientAccount {
  readonly type = AccountActionTypes.GetClientAccount;

  constructor(public payload: any = null) {}
}

export type AccountActions =
 | GetAccounts
 | LoadAccounts
 | AddAccount
 | UpsertAccount
 | AddAccounts
 | UpsertAccounts
 | UpdateAccount
 | UpdateAccounts
 | DeleteAccount
 | DeleteAccounts
 | ClearAccounts
 | GetAccountsFail
 | GetAllAccounts
//  | GetAccountList
 | NoAccountsChanged
 | GetClientAccount;

export enum AccountListFilterActionTypes {
  SelectAccountListFilters = '[AccountList] Select AccountListFilters'
}

export class SelectAccountListFilters implements Action {
  readonly type = AccountListFilterActionTypes.SelectAccountListFilters;
  constructor(public payload: AccountListFilter) {}
}

export type AccountListFilterActions = SelectAccountListFilters;
